import { useAppSelector } from '../../effects/useAppSelector';
//import { BankLink } from '../amrPipeline/common/BankLink';
import { constants } from '../../constants';
import { OnHoverTooltip } from '../common/OnHoverTooltip';
import { TextEllipsis } from '../common/TextEllipsis';

interface LoanArrangerBankLinkProps {
    companyReferenceName: string;
}

export function LoanArrangerBankLink({ companyReferenceName }: LoanArrangerBankLinkProps) {
    const arranger = useAppSelector(s => s.entities.arrangers.items[companyReferenceName]);
    const debtInvestor = useAppSelector(s => s.entities.debtInvestors.items[companyReferenceName]);
    const collateralManager = useAppSelector(s => s.entities.collateralManagers.items[companyReferenceName]);

    // KM-4457 LM:: Aggregated:: Remove Banks profile links from Arranger & Co-Arranger short codes
    // if (arranger) {
    //     return (
    //         <BankLink
    //             referenceName={arranger.referenceName}
    //             legalName={arranger.legalName}
    //             code={arranger.code}
    //             overlayText={arranger.legalName}
    //         />
    //     );
    // }

    const company = arranger ?? debtInvestor ?? collateralManager;
    const code =  company?.code?.toUpperCase();
    const legalName = company?.legalName;

    if (!code && !legalName) {
        return <>{constants.emptyPlaceholder}</>;
    }

    return (
        <OnHoverTooltip overlay={legalName}>
            <TextEllipsis>{code || legalName}</TextEllipsis>
        </OnHoverTooltip>
    );
}
